import {
  Base,
  Component,
  Inject,
  Prop,
  Provide
} from '@/vue-property-decorator'
import { GameCardCommonProps } from '../../common.type'
import BtnCircleEntry from './btnCircleEntry'
import BtnEntry from './btnEntry'
import PlayEntry from './playEntry'
import style from './style.module.scss'

/** 入口类型 */
export enum EntryType {
  /** 按钮形式 */
  Btn = 'btn',
  /** 播放器形式 */
  Play = 'play'
}
type State = {
  /** 进入按钮展示方式 [btn:按钮] [play:播放器]*/
  entryType?: EntryType
}
type Props = {
  /** 背景图片地址 */
  bgImgUrl?: string
}

/** 鼠标悬浮遮罩层 */
@Component<MaskHover>({
  name: 'MaskHover'
})
export default class MaskHover extends Base<State, Props> {
  /** 按钮入口 */
  public static BtnEntry = BtnEntry
  /** 圆形按钮入口 */
  public static BtnCircleEntry = BtnCircleEntry
  /** 播放器入口 */
  public static PlayEntry = PlayEntry
  /** 完整图片路径(HK版式) */
  public static getBgImgUrlHK = () =>
    `/lobby_asset/{layout}-{bg}-{skin}/web/home/img_play.png`

  @Inject()
  private cardProps!: Required<GameCardCommonProps>

  @Prop()
  protected bgImgUrl!: Props['bgImgUrl']

  state: State = {
    entryType: undefined
  }
  /** 设置类型,由实际的子项进行设置 */
  @Provide()
  protected setEntryType(entryType: EntryType) {
    this.state.entryType = entryType
  }

  render() {
    const { isAtSwiper, atSwiperDomId } = this.cardProps
    // 类样式
    const classes = {
      'mask-hover': true,
      'theme-mask-hover': true, // 它已废弃,请直接使用 mask-hover
      [style['mask-hover']]: true,
      [style[`type-${this.state.entryType as EntryType}`]]: Boolean(
        this.state.entryType
      )
    }
    //有背景图则要插入背景图
    if (this.bgImgUrl) {
      return (
        <my-img
          class={classes}
          options={{ type: 'div', lazy: !isAtSwiper, immediate: isAtSwiper }}
          syncGroupsSrc={isAtSwiper}
          syncGroupsWrapId={atSwiperDomId}
          src={this.bgImgUrl as string}
        >
          {this.$slots.default}
        </my-img>
      )
    }
    return <div class={classes}>{this.$slots.default}</div>
  }
}
